import react from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";

function ModalVerHistoriaGeneral(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [historiaGeneral, setHistoriaGeneral] = useState(props.historia);
    
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [enfermedadActual, setEnfermedadActual] = useState('');
    const [revisionSistemas, setRevisionSistemas] = useState('');
    const [antecedentes, setAntecedentes] = useState('');
    const [antecedentesFamiliares, setAntecedentesFamiliares] = useState('');
    const [examenFisico, setExamenFisico] = useState('');
    const [examenesComplementarios, setExamenesComplementarios] = useState('');
    const [diagnostico, setDiagnostico] = useState('');
    const [planTratamiento, setPlanTratamiento] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();
    let userdata = [];

    useEffect(() => {

        setMotivoConsulta(props.historia.motivo_consulta);
        setEnfermedadActual(props.historia.enfermedad_actual);
        setRevisionSistemas(props.historia.revision_sistemas);
        setAntecedentes(props.historia.antecedentes);
        setAntecedentesFamiliares(props.historia.antecedentes_familiares);
        setExamenFisico(props.historia.examen_fisico);
        setExamenesComplementarios(props.historia.examenes_complementarios);
        setDiagnostico(props.historia.diagnostico);
        setPlanTratamiento(props.historia.plan_tratamiento);

        setNombreProfesional(props.historia.nombre_profesional);
        setRegistroMedico(props.historia.registro_medico);
        setCodigoHabilitacion(props.historia.codigo_habilitacion);
        setFirmaimg(props.historia.firma);

    },[props.historia]);
    

    function createMarkup(arg) {
        return {
           __html: arg    };
    }



    if (loggedIn) {
        return (
                
                <div className="modal fade in" id="modalVerHistoriaGeneral">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Historia Clínica</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body" style={{paddingTop: '0.5rem'}}>


                
                            <section className="content">
                                <div className="container-fluid">

                                    <div className="row">
                                        <div className="col-md-12">

                                            <div id="historiageneral">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Motivo de consulta</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(motivoConsulta)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Enfermedad Actual</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(enfermedadActual)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Revisión por Sistemas</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(revisionSistemas)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Antecedentes Personales</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(antecedentes)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Antecedentes Familiares</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(antecedentesFamiliares)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Examen Físico</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(examenFisico)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Examenes Complementarios</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(examenesComplementarios)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Diagnóstico</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(diagnostico)}>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Plan de Tratamiento</label>
                                                        <div className="form-group" dangerouslySetInnerHTML={createMarkup(planTratamiento)}>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div id="profesional-atiende">
                                                    <div className="card-body" style={{padding: '0.7rem'}}>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                                    <br></br>
                                                                    {nombreProfesional}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="nombreProfesional">Registro médico</label>
                                                                    <br></br>
                                                                    {registroMedico}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                                    <br></br>
                                                                    {codigoHabilitacion}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                    <label htmlFor="nombreProfesional">Firma</label>
                                                                    <br></br>
                                                                    <img src={firmaimg} className="firma-profesional-hc" />
                                                                </div>
                                                            </div>  
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <button type="button" className="btn btn-primary" data-dismiss="modal">
                                                        Cerrar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ModalVerHistoriaGeneral;